export default __webpack_public_path__ + "static/system-professional-372d0adb5eb8396e0b70cce2fe334979.jpg";